import type { TIER } from './shared';

export enum CURRENCY {
  CREDITS = 'credits',
  DOLLARS = 'dollars',
}

export enum CONSUMPTION_TYPE {
  DATABASE = 'database',
  SESSION = 'session',
}

export type ConsumptionDiscount = {
  promotionName: string;
  voucherCode?: string;
  dollarAmountOff: string;
};

export type DatabaseConsumptionBreakdownItem = {
  consumptionType: CONSUMPTION_TYPE.DATABASE;
  dbid: string;
  name: string;
  tier: TIER;
  productName: string;
  pricingPlan: string;
  usage: string;
  cost: string;
  currency: CURRENCY;
  unitOfMeasure: string;
  unitCostInDollars: string;
  billingStatus: string;
};

export type GdsSessionConsumptionBreakdownItem = {
  consumptionType: CONSUMPTION_TYPE.SESSION;
  sessionId: string;
  productName: string;
  usage: string;
  cost: string;
  currency: CURRENCY;
  unitOfMeasure: string;
  unitCostInDollars: string;
};

export type ConsumptionBreakdownItem = DatabaseConsumptionBreakdownItem | GdsSessionConsumptionBreakdownItem;

export type ConsumptionBreakdown = ConsumptionBreakdownItem[];

export type Consumption = {
  totalCost: string;
  currency: CURRENCY;
  totalBreakdownCount?: number;
  breakdown?: ConsumptionBreakdown;
  usagePeriodEnd?: string;
  usagePeriodStart?: string;
  discount?: ConsumptionDiscount;
};
